// 3A Concepts — minimal, dependency-free theme JS
(function () {
  'use strict';

  // Scroll reveal — CSS defaults .reveal to visible (opacity:1). We only arm the
  // fade-in-on-scroll animation once this script actually runs, so a slow/blocked
  // script load can never leave content stuck invisible (see base.css .reveal).
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealEls = document.querySelectorAll('.reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) {
      el.classList.add('js-armed');
      io.observe(el);
    });
  }

  // Mobile nav toggle (Burger/Drawer) is initialized in an early inline <script> in
  // layout/theme.liquid — deliberately NOT here. This external file is <script defer>,
  // and per spec a script's execution (deferred or not) is blocked until every
  // <link rel="stylesheet"> that precedes it in the document has finished downloading
  // (Google Fonts + base.css). On slow mobile connections that delay could be several
  // seconds, during which the burger button would have no click handler at all. The
  // inline head script has zero stylesheets before it, so it binds instantly.

  // PDP gallery thumbs
  var mainImg = document.querySelector('[data-pdp-main]');
  if (mainImg) {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        mainImg.src = t.dataset.full || t.src;
        mainImg.alt = t.alt;
      });
    });
  }

  // FAQ accordion (also works without JS via <details>)
  document.querySelectorAll('[data-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var a = q.nextElementSibling;
      if (a) a.hidden = !a.hidden;
    });
  });

  // Wishlist (Merkliste) — persistiert lokal im Browser via localStorage
  (function () {
    var KEY = '3a_wishlist';
    var read = function () {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    };
    var write = function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    };
    var hearts = document.querySelectorAll('[data-wishlist]');
    if (!hearts.length) return;
    var saved = read();
    var paint = function (btn) {
      var on = read().indexOf(btn.getAttribute('data-wishlist-handle')) !== -1;
      btn.setAttribute('aria-pressed', String(on));
      btn.classList.toggle('is-active', on);
      btn.textContent = on ? '♥' : '♡';
    };
    hearts.forEach(function (btn) {
      paint(btn);
      btn.addEventListener('click', function (ev) {
        // Karte ist ein <a> — Navigation und Bubbling verhindern
        ev.preventDefault();
        ev.stopPropagation();
        var handle = btn.getAttribute('data-wishlist-handle');
        var list = read();
        var idx = list.indexOf(handle);
        if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
        write(list);
        // alle Buttons mit gleichem Handle synchron halten
        document.querySelectorAll('[data-wishlist-handle="' + handle + '"]').forEach(paint);
      });
    });
  })();

  // Honeypot-Spamschutz: Formular abbrechen, wenn das versteckte Feld ausgefüllt ist (Bot)
  document.querySelectorAll('[data-honeypot]').forEach(function (hp) {
    var form = hp.form;
    if (!form) return;
    form.addEventListener('submit', function (ev) {
      if (hp.value.trim() !== '') { ev.preventDefault(); ev.stopPropagation(); }
    });
  });

  // Product gallery variant swatch -> change main image (if variant has image)
  document.querySelectorAll('[data-variant-swatch]').forEach(function (s) {
    s.addEventListener('click', function () {
      var img = s.dataset.image;
      if (img && mainImg) mainImg.src = img;
      document.querySelectorAll('[data-variant-swatch]').forEach(function (x) { x.removeAttribute('data-active'); });
      s.setAttribute('data-active', '');
      var input = document.querySelector('[name="id"]');
      if (input && s.dataset.variantId) input.value = s.dataset.variantId;
    });
  });
})();
